import { countries } from "countries-list";

interface IAllCountries {
  ccode: string;
  name: string;
  phoneCode: number[];
}

export const allCountries = Object.keys(countries).map((k) => {
  return {
    ccode: k,
    name: countries[k].name,
    phoneCode: countries[k].phone,
  };
}) as IAllCountries[];
